import { groupBy, prop } from "ramda";

export default groupBy(prop("category"));
